import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {
        Products: [],
        ReportTypes: [],
        ProductText: "",
        ReportText: ""
    },
    status: 'idle', // idle loading success fail  
    additionalinfo: {},
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';
// Participant/Misc/Types/Get/{AuthToken}/	
// Participant/Misc/Type/Update/{AuthToken}/{ParticipantReportProductGuid}/{ReportProductName}/{ReportProductDescription}/	
// Participant/Misc/Type/Delete/{AuthToken}/{ParticipantReportProductGuid}/	
// Participant/Misc/Type/Create/{AuthToken}/{ReportProductName}/{ReportProductDescription}/	
export const fetchReportProducts = createAsyncThunk('reportproduct/get', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.get(WELLSUITE + "GetViewInstance/" + incomingVariable.AuthToken + "/C4F9A406-A8EE-4AA6-8518-4EBC41EC62B1"+'/')
        const data = await response.data

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})


const reportproductSlice = createSlice({
    name: 'reportproducts',
    initialState,
    reducers: {
        reportproductClear(state, action) {
            state.entities = initialState
            state.status = "idle"
            state.error = null

        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(fetchReportProducts.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchReportProducts.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success === true) {

                    const viData = action.payload.Info[0].ViewInstanceData[0].ReportProductsVI
                    const { ReportList, ReportPrompt, ProductList, ProductsPrompt } = viData
                    state.entities.Products = ProductList
                    state.entities.ReportTypes = ReportList
                    state.entities.ProductText = ProductsPrompt
                    state.entities.ReportText = ReportPrompt
                    state.status = 'success'

                } else {
                    state.status = 'failed'
                    state.error = action.payload.Status[0]
                }

            })
            .addCase(fetchReportProducts.rejected, (state, action) => {
                state.error = action.error.message
                state.status = 'failed'

            })


    }
})

export const { reportproductClear } = reportproductSlice.actions

export default reportproductSlice.reducer

export const selectReportProductEntities = (state) => state.reportproducts.entities
export const selectReportProductProductList = (state) => state.reportproducts.entities.Products
export const selectReportProductReportList = (state) => state.reportproducts.entities.ReportTypes

export const selectReportProducts = createSelector(selectReportProductEntities, (entities) =>
    Object.values(entities)
)

export const selectReportProductById = (state, ReportProductId) => {
    return selectReportProductEntities(state)[ReportProductId]
}

export const selectReportsForProduct = createSelector(
    selectReportProductReportList
    , (state, ProductTypeKeyName) => ProductTypeKeyName
    , (reports, ProductTypeKeyName) => {

        return reports.filter((report) => { return report.ProductTypeKeyName === ProductTypeKeyName })
    }
)

export const selectReportsForGuid = createSelector(
    selectReportProductReportList
    , (state, ReportTypeId_Guid) => ReportTypeId_Guid
    , (reports, ReportTypeId_Guid) => {

        return reports.filter((report) => { return report.ReportTypeId_Guid === ReportTypeId_Guid })
    }
)

export const selectActiveProducts = createSelector(
    selectReportProductProductList
    , (products) => {
        return products.filter((product) => { return product.IsActive === 1 })
    }
)    
